const ResourceList = function() {
    function ResourceList() {
        this.selector = {
            accordion: document.querySelectorAll(".resources-list > .accordion-item"),
            filecount: document.querySelector(".files-count > .count"),
            downloadnow: document.querySelector(".sticky-cta > button"),
            stickycontainer: document.querySelector(".sticky-cta"),
            productflyersnode: document.querySelector(".product-flyers-node"),
            producttechspecnode: document.querySelector(".technical-specifications-node"),
            productconfirmitynode: document.querySelector(".product-conformity-node")
        }

        this.download = { 
            files: []
        }

        this.lastscroll = this.selector.stickycontainer.offsetTop;
        this.scrollPos = 0;
        this.response = [];

        this.load();
    }

     

    ResourceList.prototype.load = function() {
        var _ = this;
        if(_.selector.accordion.length > 0) {
            _.selector.accordion.forEach(accor => {
                accor.addEventListener("click", event => {
                    if(event.target.closest(".title")) {
                        event.target.closest(".accordion-item").classList.toggle("active");
                    }                    
                })
            })
        }
        _.selector.downloadnow.addEventListener("click", event => {
            if(_.download.files.length > 1) {
                _.selector.downloadnow.classList.add("active");
                _.multipledownloads(_.download.files)
                .then(response => {
                    if(response === "completed") {}                    
                });
            }else{
              _.download.files.forEach(function(file) {
                _.selector.downloadnow.classList.add("active");
                  downloadFile(file);
                });
            }           
        });
      
      async function downloadFile(file) {
            var req = new XMLHttpRequest();
            req.open("GET", file.url, true);
            req.responseType = "blob";
        
            req.onload = function (event) {
                var blob = req.response;
                console.log(blob.size);
        
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = file.filename;
        
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
               _.selector.downloadnow.classList.remove("active");
            };
        
            req.send();
            console.log(file);
        }
      
        window.onscroll = event => {
            if ((document.body.getBoundingClientRect()).top > _.scrollPos && window.scrollY > 600) {
                _.selector.stickycontainer.classList.remove("down");
                _.selector.stickycontainer.classList.add("up");        
            } else if ((document.body.getBoundingClientRect()).top < _.scrollPos && window.scrollY > 600) {
                _.selector.stickycontainer.classList.add("sticky-me");
                _.selector.stickycontainer.classList.add("down");
                _.selector.stickycontainer.classList.remove("up");
            } else if ((document.body.getBoundingClientRect()).top > _.scrollPos && window.scrollY < 600) {
                _.selector.stickycontainer.classList.remove("sticky-me");
                _.selector.stickycontainer.classList.remove("down");
                _.selector.stickycontainer.classList.remove("up");
            }
            _.scrollPos = (document.body.getBoundingClientRect()).top;
        }
        window.onresize = event => {
            if(window.navigator.userAgent.includes("Mobile")) {
                _.lastscroll = _.selector.stickycontainer.offsetTop;
            } else {
                _.lastscroll = _.selector.stickycontainer.offsetTop;
            }
        }
        if(window.product_flyers.length > 0) {
            _.createflyersitemsnode(window.product_flyers)
            .then(response => {
                if(response.status === "done") {
                    _.addlistener(response);
                }               
            });            
        }
        if(window.product_tech_spec.length > 0) {
            _.createtechspecsitemsnode(window.product_tech_spec)
            .then(response => {
                if(response.status === "done") {
                    _.addlistener(response);
                }               
            });            
        }
        if(window.product_conformity.length > 0) {
            _.createconformityitemsnode(window.product_conformity)
            .then(response => {
                if(response.status === "done") {
                    _.addlistener(response);
                }               
            });            
        }
    }
    ResourceList.prototype.multipledownloads = async function(files) {
        var _ = this;
        var zip = new JSZip();
        var count = 0;
        var zipFilename = "GRIPPS_resources.zip";
        await files.forEach(function(file) {
        // loading a file and add it in a zip file
        JSZipUtils.getBinaryContent(file.url, async function (err, data) {
            if(err) {
                _.selector.downloadnow.classList.remove("active");
                throw err; // or handle the error
            }
                zip.file(`${file.filename}.pdf`, data, {binary:true});
                count++;
                if (count == files.length) {
                await zip.generateAsync({type:'blob'}).then(function(content) {                   
                    saveAs(content, zipFilename);
                    _.selector.downloadnow.classList.remove("active");
                });
                }
            });
        });
        return "completed";
    }
    ResourceList.prototype.createflyersitemsnode = async function(nodes) {
        var _ = this;
        _.sortdataby(nodes,"title");
        await nodes.forEach((node,index) => {
            if(index == 0) {
                let nodedivselectall = document.createElement("div");
                nodedivselectall.classList.add("item");
                let nodeinputselectall = document.createElement("input");
                nodeinputselectall.type = "checkbox";  
                nodeinputselectall.id = `product-flyers-select-all--${node.id}`;
                nodeinputselectall.classList.add("downloadable-files-select-all");
                nodedivselectall.append(nodeinputselectall);
                let nodeselectalllabel = document.createElement("label");
                nodeselectalllabel.setAttribute("for",`product-flyers-select-all--${node.id}`);
                nodeselectalllabel.textContent = `Select All`;
                nodedivselectall.append(nodeselectalllabel);
                _.selector.productflyersnode.append(nodedivselectall);
            }
            let nodediv = document.createElement("div");
           nodediv.classList.add("item");
            nodediv.classList.add("counter"+node.counter );
            let nodeinput = document.createElement("input");
            nodeinput.type = "checkbox";
            nodeinput.id = `product-flyers--${node.id}`;
            nodeinput.classList.add("downloadable-files");
            nodeinput.setAttribute("data-filename",node.handle);
            nodeinput.setAttribute("data-url",node.url);
            nodediv.append(nodeinput);
            let nodelabel = document.createElement("label");
            nodelabel.setAttribute("for",`product-flyers--${node.id}`);
            nodelabel.textContent = node.title;
            nodelabel.setAttribute("title",node.language);
            nodediv.append(nodelabel);
            _.selector.productflyersnode.append(nodediv);
        })
        return {node: "flyers", status: "done" };
    }
    ResourceList.prototype.createtechspecsitemsnode = async function(nodes) {
        var _ = this;
        _.sortdataby(nodes,"title");
        await nodes.forEach((node,index) => {
            if(index == 0) {
                let nodedivselectall = document.createElement("div");
                nodedivselectall.classList.add("item");
                let nodeinputselectall = document.createElement("input");
                nodeinputselectall.type = "checkbox";  
                nodeinputselectall.id = `product-tech-specs-select-all--${node.id}`;
                nodeinputselectall.classList.add("downloadable-files-select-all");
                nodedivselectall.append(nodeinputselectall);
                let nodeselectalllabel = document.createElement("label");
                nodeselectalllabel.setAttribute("for",`product-tech-specs-select-all--${node.id}`);
                nodeselectalllabel.textContent = `Select All`;
                nodedivselectall.append(nodeselectalllabel);
                _.selector.producttechspecnode.append(nodedivselectall);
            }
            let nodediv = document.createElement("div");
            nodediv.classList.add("item");
            nodediv.classList.add("counter"+node.counter );
            let nodeinput = document.createElement("input");
            nodeinput.type = "checkbox";
            nodeinput.id = `product-tech-specs--${node.id}`;
            nodeinput.classList.add("downloadable-files");
            nodeinput.setAttribute("data-filename",node.handle);
            nodeinput.setAttribute("data-url",node.url);
            nodediv.append(nodeinput);
            let nodelabel = document.createElement("label");
            nodelabel.setAttribute("for",`product-tech-specs--${node.id}`);
            nodelabel.textContent = node.title;
          nodelabel.setAttribute("title",node.language);
            nodediv.append(nodelabel);
            _.selector.producttechspecnode.append(nodediv);
        })
        return { node: "techspec", status: "done" };
    }
    ResourceList.prototype.createconformityitemsnode = async function(nodes) {
        var _ = this;
        _.sortdataby(nodes,"title");
        await nodes.forEach((node,index) => {
            if(index == 0) {
                let nodedivselectall = document.createElement("div");
                nodedivselectall.classList.add("item");
                let nodeinputselectall = document.createElement("input");
                nodeinputselectall.type = "checkbox";  
                nodeinputselectall.id = `product-conformity-select-all--${node.id}`;
                nodeinputselectall.classList.add("downloadable-files-select-all");
                nodedivselectall.append(nodeinputselectall);
                let nodeselectalllabel = document.createElement("label");
                nodeselectalllabel.setAttribute("for",`product-conformity-select-all--${node.id}`);
                nodeselectalllabel.textContent = `Select All`;
                nodedivselectall.append(nodeselectalllabel);
                _.selector.productconfirmitynode.append(nodedivselectall);
            }
            let nodediv = document.createElement("div");
           nodediv.classList.add("item");
            nodediv.classList.add("counter"+node.counter );
            let nodeinput = document.createElement("input");
            nodeinput.type = "checkbox";
            nodeinput.id = `product-conformity--${node.id}`;
            nodeinput.classList.add("downloadable-files");
            nodeinput.setAttribute("data-filename",node.handle);
            nodeinput.setAttribute("data-url",node.url);
            nodediv.append(nodeinput);
            let nodelabel = document.createElement("label");
            nodelabel.setAttribute("for",`product-conformity--${node.id}`);
            nodelabel.textContent = node.title;
          nodelabel.setAttribute("title",node.language);
            nodediv.append(nodelabel);
            _.selector.productconfirmitynode.append(nodediv);
        })
        return { node: "conformity", status: "done" };
    }
    ResourceList.prototype.sortdataby = function(data, bykey) {
        let sortedData;
        if(bykey === 'title') {
          sortedData = data.sort(function(a,b) {
            let x = a.title.toLowerCase();
            let y = b.title.toLowerCase();
            if(x > y) { return 1; }
            if(x < y) { return -1; }
            return 0;
          });
        } else {
          sortedData = data.sort(function(a,b) {
            return a.sku - b.sku;
          })
        }
        return sortedData;
    }
    ResourceList.prototype.addlistener = async function(response) {
        var _ = this;
        _.response.push(response);
        let responseflyers = _.response.find(res => res.node === "flyers" && res.status === "done");
        let responsetechspecs = _.response.find(res => res.node === "techspec" && res.status === "done");
        let responseconformity = _.response.find(res => res.node === "conformity" && res.status === "done");
        if(responseflyers && responsetechspecs && responseconformity) {
            const downloadfiles = document.querySelectorAll("input.downloadable-files");
            if(downloadfiles.length > 0) {
                downloadfiles.forEach(input => {
                    input.addEventListener("change", event => {
                            if(event.target.checked && event.target.dataset.url && event.target.dataset.filename) {                            
                                _.download.files.push({filename: event.target.dataset.filename, url: event.target.dataset.url});
                            } else {
                                _.download.files = _.download.files.filter(file => !file.filename.includes(event.target.dataset.filename));
                            }
                        _.selector.filecount.innerHTML = _.download.files.length;
                    })
                })
            }
            const downloadfilesselectall = document.querySelectorAll("input.downloadable-files-select-all");
            if(downloadfilesselectall.length > 0) {
                downloadfilesselectall.forEach(async input => {
                    input.addEventListener("change", async event => {
                        const downloadlinks = event.target.closest(".accordion-item").querySelectorAll("input.downloadable-files");
                        if(event.target.checked) {
                            if(downloadlinks.length > 0) {
                               await downloadlinks.forEach(async input => {
                                input.checked = true;
                                _.download.files.push({filename: input.dataset.filename, url: input.dataset.url});                   
                                })
                                _.selector.filecount.innerHTML = _.download.files.length;
                            }
                        } else {
                            if(downloadlinks.length > 0) {
                               await downloadlinks.forEach(async input => {
                                input.checked = false;
                                _.download.files = _.download.files.filter(file => !file.filename.includes(input.dataset.filename));
                                })
                                _.selector.filecount.innerHTML = _.download.files.length;
                            }
                        }
                    })
                })
            }
        }       
    }
    ResourceList = new ResourceList;
}

ResourceList();